import { APP_NAME } from 'app-config'

export const getTemporaryEmail = ({ uuid }: { uuid: string }): string => {
  if (!uuid) {
    return ''
  }

  return `pending-email-${uuid}@${APP_NAME}.temporary`
}
